<template>

  <div class="workshops-courses">

    <nav-1></nav-1>

    <hero :image="hero"></hero>

    <div class="content-text">
      <h1>Short Courses</h1>
      <h4 class="size__content__narrow pos__content__center">
        Exciting news! We are curating a new course offering which provides a comprehensive and in-depth introduction to a range of design and printing techniques. Drawing on our vast experience, each workshop is conducted in small groups, ensuring maximum support and guidance from our experienced tutors.
        <br><br>
        Sign up to register your interest
      </h4>
      <!-- <h4 class="">
        Sign up to register your interest
      </h4> -->
    </div>

    <div class="contact-form">
      <div class="size__content__narrow pos__content__center">
        <!-- <h4 class="">
          Sign up to register your interest
        </h4> -->
        <!-- <form class="">
          <input type="email" name="" value="" placeholder="Enter your email">
          <button type="button" name="button">Sign up</button>
        </form> -->
        <!-- Begin MailChimp Signup Form -->

        <mailchimp></mailchimp>

        <!--End mc_embed_signup-->
      </div>
    </div>

    <div class="action-wrapper">
      <div class="action">
        <h3>Get in touch to learn more about our courses, or any general enquiries on workshops.</h3>
        <a href="mailto:learn@hatopress.net">learn@hatopress.net</a>
        <a href="tel:+44-207-729-5585">+44 (0)207 729 5585</a>
      </div>
    </div>

  </div>

</template>

<script>

import Nav1 from '@/components/Nav1'
import Flickity from '@/components/Flickity'
import Hero from '@/components/Hero'
import Mailchimp from '@/components/Mailchimp'

export default {
  components: {
    Nav1,
    Flickity,
    Hero,
    Mailchimp
  },
  data () {
    return {
      hero: require('../assets/workshops/whitechapel-cropped-1.jpg'),
      carousel: [
        {
          text: 'Bao',
          image: 'https://scontent-lhr3-1.cdninstagram.com/t51.2885-15/e35/17438461_174435699740537_1721658144775471104_n.jpg'
        }
      ],
      flickityOptions: {
        // contain: true,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
        setGallerySize: true,
        autoPlay: 3000
      }
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.content-text {
  margin: auto;
  padding: 0 1rem;
  margin: 2rem auto 0;
  text-align: left;
  max-width: 1000px;
}
.contact-form {
  /*text-align: center;*/
  padding: 1rem 1rem 3rem;
  margin: 0 auto 0;
  /*background: hsl(186, 81%, 57%);*/
}

h2 {
  margin-top: 0;
  /*text-align: center;*/
}



.action-wrapper {
  background: #f0f0f0;
  padding: 1rem 0;
}

.action {
  padding: 2rem 0;
  margin: 0 auto;
  max-width: 600px;
  text-align: center;
}
.action a {
  display: inline-block;
  margin: 1rem .5rem;
  padding: .5em 1em;
  border-radius: 5px;
  /*border: 1px solid #000;*/
  background: hsl(158, 81%, 57%)
}
.action a:hover {
  background: hsl(158, 81%, 77%);
}





@media screen and (max-width: 1024px) {
  .quotes {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
@media screen and (max-width: 768px) {
}
@media screen and (max-width: 640px) {
  .quotes {
    flex-direction: column;
  }
  .quote {
    width: 100%;
    margin-top: 0;
    margin-bottom: 1rem;
  }
  .action a {
    margin: .5em 1em;
  }
}
</style>



// WEBPACK FOOTER //
// WorkshopsCourses.vue?00d0f00e